import React, { useState, useEffect } from 'react';
import './file-upload.css';
import servicesApi from '../../seller-apis/servicesApi';
import convertFileToWebP from '../../utilities/convertFileToWebP';
import axios from 'axios';
import { ProgressBar } from 'react-bootstrap';
import api from "../../seller-apis/api";//SL-818
import { GenUtilities } from '../../utilities/GenUtilities';
function FileUploader(props) {
    const [extractedName, setExtractedName] = useState(null);
    const [preview, setPreview] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0)
    const {
        label,
        subLabel,
        state,
        setState,
        id,
        accept,
        fileSize,
        error,
        setError,
        uploadDesc,
        mainLabel,
        filename,
        setfilename
    } = props;

    useEffect(() => {
        if (!filename) {
            setfilename(null);
            setPreview(null);
        }
        //SL-748 For Preview
        else {
            setPreview(filename);
            if (filename.startsWith('https://toolsvilla-prod.s3.ap-south-1.amazonaws.com')) {
                const extractedFileName = isPdf(filename) ? filename.split("/").pop() : filename.split(".com/")[1]
                setExtractedName(extractedFileName);
            }
            else{
                setExtractedName(filename)
                setfilename(filename);
            }
        }
    }, [filename]);

    const handleFileChange = async (e) => {
        setError(null)
        if (e && e?.target?.files) {
            const file = e?.target?.files[0];
            if ((file.size) / 1024 >= fileSize) {
                let { size, unit } = fileSize >= 1024
                    ? { size: fileSize / 1024, unit: 'MB' }
                    : { size: fileSize, unit: 'KB' };
                setError(`*Max Image size ${size} ${unit}.`);
            } else if (
                !accept.split(",").some(type =>
                    type.trim() === file.type ||
                    (type.trim() === "image/*" && file.type.startsWith("image/"))
                )
            ) {
                setError(`*Invalid file.`);
            }
            else {
                await uploadMedia(file)
            }
        } else {
            setfilename(null);
            setState(null)
            setPreview(null);
        }
    };

    const isPdf = (url) => {
        return url && url.toLowerCase().includes('.pdf');
    }

    const uploadMedia = async (mFile) => {
        try {
            if (mFile.type === "application/pdf") {
                const strArray = mFile.name.split(".");
                const newName = strArray[0] + "." + strArray[1];
                const vendorId = localStorage.getItem('vendorId');
                const imageFinal = GenUtilities.removeSpacesFromName("pdf_" + vendorId + "_" + newName)
                var data = {
                    imageName: imageFinal,
                    type: "products",
                };
                const res = await servicesApi.saveImage(data)
                const response = await axios({
                    method: "put",
                    url: res.data,
                    data: mFile,
                    onUploadProgress: data => {
                        setUploadProgress(Math.round((100 * data.loaded) / data.total))
                    },
                })
                if (response.status === 200) {
                    setfilename(`https://s3.toolsvilla.com/mob/products/${imageFinal}`)
                }
            }
            else {
                let convertedImg = await convertFileToWebP(mFile);
                const originalBlob = convertedImg;
                const strArray = convertedImg.name.split(".");
                const newName = strArray[0] + "-" + new Date().getTime() + "." + strArray[1];
                const renamedFile = new File([originalBlob], newName, { type: convertedImg.type });
                const vendorId = localStorage.getItem('vendorId');
                const imageFinal = GenUtilities.removeSpacesFromName("img_" + vendorId + "_" + newName)
                const data = {
                    imageName: "seller/brand-store/" + imageFinal,
                };
                //<Start-Here> Change media Storage Ticket: SL-818
                // await the upload URL
                //const uploadURLRes = await servicesApi.getUploadUrl(data);
                const uploadURLRes = await api.product.saveProductImage(data);
                // now upload the file using the signed URL
                const formData = new FormData();
                formData.append("file", renamedFile);
                const uploadResponse = await axios({
                    method: "put",//"post",
                    url: uploadURLRes.data,
                    data: renamedFile,//formData,
                    onUploadProgress: data => {
                        setUploadProgress(Math.round((100 * data.loaded) / data.total))
                    },
                });
                //setfilename(uploadResponse?.data?.result?.variants?.[0])
                setfilename(uploadResponse?.config?.url?.split('?')[0])
                //</End-Here> Change media Storage Ticket: SL-818
            }
        } catch (error) {
            console.error(error)
        }
        finally {
            setUploadProgress(0)
        }
    }


    return (
        <>
            <div className='file-upload-container'>
                <label>{mainLabel}</label>
                <div className='file-upload-brand'>

                    <input type="file" id={id} hidden onClick={(e) => e.target.value = null} onChange={handleFileChange} accept={accept} />

                    {
                        filename ?
                            <>
                                {preview ? (

                                    isPdf(filename) ? (
                                        <>
                                            <div className='brand-pdf-cntn'>
                                                <img src='/file-icon.png' alt="preview" className="uploaded-image" />
                                            </div>

                                        </>
                                    ) : (
                                        <img src={'https://s3.toolsvilla.com/'+extractedName} alt="preview" className="uploaded-image" />
                                    )

                                ) : null}
                                {' '}
                                <img src="/brand/cross-circle.png" alt='cross-icon' height={27} className='ms-auto me-2 cursor-pointer cross-brand-upload' onClick={() => handleFileChange(null)} />
                            </> :
                            <>
                                <label htmlFor={id}>
                                    <img src="/brand/upload-icon.png" alt='upload-icon' height={27} className='ms-auto me-2 cursor-pointer' onClick={() => document.getElementById(id).click()} />
                                    <p className='label1'>{label}</p>
                                    {' '}
                                    <p className='label2'>{subLabel}</p>
                                </label>
                            </>
                    }
                </div>
                {uploadProgress > 0 && (
                    <ProgressBar
                        id="progress-B"
                        now={uploadProgress}
                        label={`${uploadProgress}%`}
                    />
                )}
                {

                    preview ? filename &&
                        isPdf(filename) ? <p className='filename fs-12' style={{ wordBreak: 'break-word', width: '165px' }}>{extractedName}</p> : <></> : <></>
                }
                <div className='file-upload-desc'>
                    <p>{uploadDesc}</p>
                </div>
                {
                    error ?
                        <span className="text-danger" style={{ fontFamily: 'Poppins', fontWeight: '500' }}>{error}</span>
                        : null
                }
            </div>
        </>
    );
}

export default FileUploader;
